import { Users, MapPin, Heart } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      icon: Users,
      title: "The Group",
      description: "We carefully select 20 compatible singles (10 men, 10 women) who share a love for travel and adventure.",
      color: "text-[#FF6F61]",
    },
    {
      number: "02",
      icon: MapPin,
      title: "The Journey",
      description: "From hidden beaches to mountain treks, our itineraries are packed with fun activities designed to break the ice naturally.",
      color: "text-[#FF6F61]",
    },
    {
      number: "03",
      icon: Heart,
      title: "The Spark",
      description: "Travel reveals character. By the end of the trip, you'll have made 19 new friends, and perhaps, found the one who makes your heart race.",
      color: "text-[#FF6F61]",
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-gradient-sunset">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Simple & Clear
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-foreground mb-4">
            The 'How It Works'
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Three simple steps to find connection through travel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card
                key={index}
                className="border-0 shadow-card hover:shadow-elevated transition-all duration-300 hover:-translate-y-1 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="p-8 text-center">
                  <div className="text-6xl font-bold text-muted-foreground/20 mb-4">
                    {step.number}
                  </div>
                  <div className={`w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6 ${step.color}`}>
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="font-display text-2xl font-bold text-foreground mb-4">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;

